angular.module('SpidApp')

.controller('InventoryListController', 
		['$scope', '$stateParams', '$filter', '_', 'InventoryService', 'UserService', 'ProductService', 'OperationalProductService', 'Toaster', '$timeout',    
function ($scope,   $stateParams,   $filter,   _,   InventoryService,   UserService,   ProductService,   OperationalProductService,   Toaster,   $timeout) {
    
	if (!$stateParams.agencyId) {
        throw 'InventoryListController() - You should provide an agency id'
    }
    
    var agencyId = $stateParams.agencyId
    
    $scope.filter = {};
    $scope.sort = 'inventory.updated_at';
    $scope.asc = true;
    
    var filterTypeArraySaved = [];
    var filterUserArraySaved = [];
    var InventoryType = {
    		  PRODUCTS		: 'PRO'
    		, PRODUCTS_OP 	: 'OPE'
    }
    
    var fetchInventories = function() {
    	UserService.all().then(function(users) {
    		$scope.users = users;
    		InventoryService.findByAgencyId(agencyId).then(function(inventories) {
    	    	$scope.inventories = _.map(inventories, function(inventory) {
    	    		var user = _.find(users, function(user) {
    	    	    	return user.id === inventory.user_id;
        	    	});
    	    		if (user) {
    	    			inventory.userFirstname = user.firstname;
    	    			inventory.userLastname = user.lastname;
    	    		}
    	    		return inventory;
    	    	});
    	    }).then(function() {
        	    initFilterTypeArrayDefault();
        	    initFilterUserArrayDefault();
            	$scope.filterInventories();
    	    })
    	});
    }
    fetchInventories();
    
    
    $scope.printInventoryList = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
    	$timeout(function() {
    		window.print();
    	}, 50);
	}
    
    $scope.filterInventories = function() {
    	filterTypeArraySaved =  _.map($scope.filterTypeArray, _.clone);
    	filterUserArraySaved =  _.map($scope.filterUserArray, _.clone);
    	$scope.filteredInventories = $filter('ordersInventoriesByType')($scope.inventories, $scope.filterTypeArray)
    	$scope.filteredInventories = $filter('ordersInventoriesByUser')($scope.filteredInventories, $scope.filterUserArray);
    }
    
    /** Filtre Type ****/
    $scope.resetFilterType = function($event) {
    	if ($event) {
			$event.preventDefault()
			$event.stopPropagation()
		}
    	$scope.filterTypeArray = _.map(filterTypeArraySaved, _.clone);
    	$scope.toggleTypeFilter('init');
    }
    
    $scope.toggleTypeFilter = function(id) {
    	if (!id && id !== 0) {
    		$scope.filterTypeArray = _($scope.filterTypeArray).map(function(filter) {
    			filter.checked = $scope.filter.all;
    			return filter;
    		})
    	}
    	else {
    		$scope.filter.all = true;
    		for(var i = 0; i < $scope.filterTypeArray.length ; i++) {
    			if (!$scope.filterTypeArray[i].checked) {
    				$scope.filter.all = false;
    				break;
    			}
    		}
    	}
    }
    
    var initFilterTypeArrayDefault = function() {
    	$scope.filterTypeArray = [
                  { id: InventoryType.PRODUCTS, 	label: 'Produits à la vente', 			checked: true }
                , { id: InventoryType.PRODUCTS_OP, 	label: 'Produits de fonctionnement', 	checked: true }
       	 ];
    }
    
    /** Filtre User ****/
    $scope.resetFilterUser = function($event) {
    	if ($event) {
			$event.preventDefault()
			$event.stopPropagation()
		}
    	$scope.filterUserArray = _.map(filterUserArraySaved, _.clone);
    	$scope.toggleUserFilter('init');
    }
    
    $scope.toggleUserFilter = function(id) {
    	if (!id && id !== 0) {
    		$scope.filterUserArray = _($scope.filterUserArray).map(function(filter) {
    			filter.checked = $scope.filter.allUser;
    			return filter;
    		})
    	}
    	else {
    		$scope.filter.allUser = true;
    		for(var i = 0; i < $scope.filterUserArray.length ; i++) {
    			if (!$scope.filterUserArray[i].checked) {
    				$scope.filter.allUser = false;
    				break;
    			}
    		}
    	}
    }
    
    var initFilterUserArrayDefault = function() {
    	$scope.filterUserArray = _.chain($scope.users).filter(function(user) {
    		return user.hasRoleGuichetier();
    	}).map(function(user) {
    		return {
    			id		: user.id,
    			label	: user.firstname + ' ' + user.lastname,
    			checked	: true
    		}
    	}).value();
    }
}])
